(function(){
    const el = '.kb-js--animated-button'
    const scrollTriggerDistance = 300
    const DOM = document.querySelector(el)

    const isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1

    const retracted = 'kb-hero-general__animated-button-container--retracted'

    if(!DOM) return false
        console.log("scrolling",document.documentElement.scrollTop)

    if(!isMobile) {
        DOM.addEventListener('mouseover',()=>DOM.classList.remove(retracted))
        DOM.addEventListener('mouseleave',()=>DOM.classList.add(retracted))
    } else {
        DOM.addEventListener('click',()=> {
            if(DOM.classList.contains(retracted) ) {
                DOM.classList.remove(retracted)
            } else if (!DOM.classList.contains(retracted) ) {
                DOM.classList.add(retracted)
            }
        })
    }
    
})()
 
